const MIN_MASKED_LENGTH = 600;

const generateGarbage = (length) => {
  const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=¡¢£¤¥¦§¨©ª«¬®¯°±²³´µ¶·¸¹º»¼½¾¿×÷";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
    // Add spaces less frequently for denser 'encrypted' look
    if (i > 0 && i % (Math.floor(Math.random() * 15) + 10) === 0) result += " ";
  }
  return result;
};

export const stripHtmlToText = (content = "") => {
  return String(content)
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/(p|div|h[1-6])>/gi, "\n")
    .replace(/<li>/gi, "- ")
    .replace(/<\/li>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
};

// Helper to mask content based on blur info
export const getMaskedContent = (content, blurInfo) => {
  if (!content) return { text: "", overlayTop: 100 };
  if (!blurInfo || !blurInfo.required || !blurInfo.total) return { text: content, overlayTop: 100 };

  // content.length might differ slightly from blurInfo.total if sanitized differently,
  // but we use the ratio to determine cut point.
  // required is the *excess* or *unpaid* portion? 
  // Based on usage: top = 1 - (required/total). So (required/total) is the HIDDEN portion ratio.

  const hiddenRatio = Math.min(1, Math.max(0, blurInfo.required / (blurInfo.total || 1)));
  const visibleRatio = 1 - hiddenRatio;

  const keepLength = Math.floor(content.length * visibleRatio);

  // If we keep 100%, return original
  if (keepLength >= content.length) return { text: content, overlayTop: 100 };

  const visiblePart = content.substring(0, keepLength);

  // Calculate target total length to ensure overlay has space
  const targetTotal = Math.max(content.length, MIN_MASKED_LENGTH);
  const hiddenPartLength = targetTotal - keepLength;

  let maskedContent = visiblePart + " " + generateGarbage(hiddenPartLength);

  // Ensure minimum length for better overlay visibility on small responses
  const ENSURED_MIN_LENGTH = 800;
  if (maskedContent.length < ENSURED_MIN_LENGTH) {
    const needed = ENSURED_MIN_LENGTH - maskedContent.length;
    maskedContent += " " + generateGarbage(needed);
  }

  // Calculate overlay top to ensure garbage is blurred
  // We want the overlay to start exactly where the "garbage" (blur) begins.
  let overlayTop = (visiblePart.length / maskedContent.length) * 100;

  return { text: maskedContent, overlayTop };
};
